exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.breadcrumbs {\n  padding-top: 1em;\n}\n@media print {\n.breadcrumbs {\n    display: none;\n}\n}\nimg {\n  height: 30em;\n  width: 20em;\n  vertical-align: middle;\n}\n.margin-one {\n  width: 16em;\n}\n.margin-two {\n  margin-top: 0.5em;\n}\n.navbar-toggle:hover {\n  background: none !important;\n}\n.navbar-toggle:focus {\n  background: none !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-21c62a07","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/header/header.vue
// module id = 897
// module chunks = 1